import { object, string } from "yup";

import { emailRequired, phoneNumber } from "@covertree/utils";

export interface NotInStateModalForm {
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  usa_state: string;
}

export const notInStateModalFormValidator = object({
  firstname: string().required("First name is required"),
  lastname: string().required("Last name is required"),
  email: emailRequired(),
  phone: phoneNumber().required("Phone number is required"),
  usa_state: string().required("Client's state is required"),
});
